import axios from "axios";

export default class axiosClient {

  async getProfile(id) {
    const headers = {
      accept: "application/json",
      "Content-Type": "application/json"
    };
    const { data } = await axios.get(`api/users/${id}`, { headers });
    return data;
  }

  async getActiveSession(params) {
    const headers = {
      accept: "application/ld+json",
      "Content-Type": "application/ld+json"
    };
    const { data } = await axios.get("api/fingerprints", { headers, params });
    return data;
  }

  async closeActiveSession() {
    const headers = {
      accept: "application/json",
      "Content-Type": "application/json"
    };
    const resp = await axios.get("api/users/forget_login", { headers });
    return resp;
  }

  async editProfile(id, body) {
    const headers = {
      accept: "application/json",
      "Content-Type": "application/merge-patch+json"
    };
    await axios.patch(`api/users/${id}`, body, { headers });
  }

  async generateSystemWallet() {
    const headers = {
      accept: "application/json",
      "Content-Type": "application/json"
    };
    return await axios.post("/api/eth_addresses/generate", { headers });
  }

  async confirmEmail(url) {
    const headers = {
      accept: "application/json",
      "Content-Type": "application/merge-patch+json"
    };
    return await axios.get(url, { headers });
  }

  async fakeKYCSuccess() {
    return await axios.get("/api/update-kyc");
  }

  async get2faMandatory() {
    return await axios.get("/api/is-2fa-mandatory");
  }
}